import styled from 'styled-components'
import Table from '../../components/table'

const StyledTable = styled(Table)`
    background-color: #ffffff;
    margin: 0.625rem 0 0.625rem 0;
    width: 90vw;
    border-radius: 5px;
    box-sizing: border-box;
`
export default StyledTable
